import { useMemo } from 'react';
import type { Check, ChecklistItem } from '../lib/types';
import { isWeekend } from '../lib/dates';
import { computeColorState } from '../lib/staleness';
import ChecklistRow from './ChecklistRow';

interface Props {
  items: ChecklistItem[];
  checks: Check[];
  today: string;
  onToggle: (itemId: string) => void;
}

export default function Checklist({ items, checks, today, onToggle }: Props) {
  const weekend = isWeekend(today);

  const visible = useMemo(
    () => [...items].sort((a, b) => a.priorityOrder - b.priorityOrder).filter((i) => !(weekend && i.weekdaysOnly)),
    [items, weekend],
  );

  const checksByItem = useMemo(() => {
    const map = new Map<string, Check[]>();
    for (const c of checks) {
      const arr = map.get(c.itemId) ?? [];
      arr.push(c);
      map.set(c.itemId, arr);
    }
    return map;
  }, [checks]);

  return (
    <ul className="checklist">
      {visible.map((item) => {
        const itemChecks = checksByItem.get(item.id) ?? [];
        const isCheckedToday = itemChecks.some((c) => c.date === today);
        const colorState = computeColorState(item, itemChecks, today);
        return (
          <li key={item.id} className="checklist__item">
            <ChecklistRow
              item={item}
              isCheckedToday={isCheckedToday}
              colorState={colorState}
              onToggle={() => onToggle(item.id)}
            />
          </li>
        );
      })}
    </ul>
  );
}
